import React from 'react'
import {Select} from 'antd'
import {numVal} from '../../../../modules/Utils'

export const invoicedFilterMethod = (filter, row) => {
  const invoicedArray = ['Invoiced']
  const partInvoiced = ['Part Invoiced']
  if (filter.value === 'all') return true
  switch (filter.value) {
    case 'Held':
      return row[filter.id] === 'Held'
    case 'pending-invoice':
      return (
        partInvoiced.includes(row[filter.id]) || row[filter.id] === undefined
      )
    case 'fully-invoiced':
      return invoicedArray.includes(row[filter.id])
    case 'part-invoiced':
      return partInvoiced.includes(row[filter.id])
    case 'invoiced':
      return (
        partInvoiced.includes(row[filter.id]) ||
        invoicedArray.includes(row[filter.id])
      )
    case 'none-invoiced':
      return (
        !partInvoiced.includes(row[filter.id]) &&
        !invoicedArray.includes(row[filter.id])
      )
    default:
      return true
  }
}
export const invoicedQtyFilterMethod = (filter, row) => {
  if (filter.value === 'all') return true
  switch (filter.value) {
    case 'none-invoiced':
      return numVal(row, 'invoiced') === 0
    case 'invoiced':
      return numVal(row, 'invoiced') > 0
    case 'part-invoiced':
      return (
        numVal(row, 'invoiced') > 0 &&
        numVal(row, 'invoiced') < numVal(row, 'unit')
      )
    case 'fully-invoiced':
      return numVal(row, 'invoiced') === numVal(row, 'unit')
    case 'pending-invoice':
      return (
        numVal(row, 'invoiced') === 0 ||
        (numVal(row, 'invoiced') > 0 &&
          numVal(row, 'invoiced') < numVal(row, 'unit'))
      )
  }
}

function InvoicedFilter({onChange, filter}) {
  return (
    <Select
      onChange={value => onChange(value)}
      style={{width: '100%'}}
      value={filter ? filter.value : 'all'}>
      <Select.Option value="all">All</Select.Option>
      <Select.Option value="pending-invoice">Pending</Select.Option>
      <Select.Option value={'fully-invoiced'}>Fully Invoiced</Select.Option>
      <Select.Option value={'part-invoiced'}>Part Invoiced</Select.Option>
      <Select.Option value={'invoiced'}>Invoiced</Select.Option>
      <Select.Option value={'none-invoiced'}>None Invoiced</Select.Option>
    </Select>
  )
}

InvoicedFilter.propTypes = {}
InvoicedFilter.defaultProps = {}

export default InvoicedFilter
